import { useMutation } from '@tanstack/react-query';
import { ApiClient, useApiClient } from 'api/context-provider/useApiClient';
import { ApiError, InferFetchData, throwOnError } from 'api/helpers';
import { operations } from 'api/schema';

export type CreateLegalDocumentMutationData = operations['storeLegalDocumentVersions']['requestBody']['content']['application/json'];

async function storeLegalDocumentVersions(apiClient: ApiClient, data: CreateLegalDocumentMutationData) {
  return apiClient.POST('/op/v2/legal-document-versions', {
    body: data,
  });
}

export function useCreateLegalDocumentMutation() {
  const apiClient = useApiClient();
  return useMutation<InferFetchData<typeof storeLegalDocumentVersions>, ApiError, CreateLegalDocumentMutationData>({
    mutationKey: ['CreateLegalDocument'],
    mutationFn: (data) => throwOnError(storeLegalDocumentVersions(apiClient, data)),
  });
}
